import Profile from "../module/userProfile"

const profile = new Profile();


const ROLE_PROFESSOR = "DOZENT";

const ROLE_STUDENT = "KURSTEILNEHMER";

class Role {

  constructor() {
    this.user = undefined;
  }

  async getUserProfile() {
    if (this.user === undefined) {
      let userProfile = await profile.getUserProfile();
      if (userProfile) {
        this.user = userProfile;
      } else {
        return null;
      }
    }
    return this.user;
  }

  async getRoles() {
    if (this.user === undefined) {
      await this.getUserProfile();
    }
    return this.user.rollen;
  }

  async hasRole(role) {
    if (this.user === undefined) {
      await this.getUserProfile();
    }
    if (
      this.user !== undefined &&
      this.user.rollen &&
      Array.isArray(this.user.rollen)
    ) {
      if (this.user.rollen.map((r) => r.name).includes(role)) {
        return true;
      }
    }
    return false;
  }
}

export default Role;
